import React from 'react';
import Route from '../Route';
import AccountSwitcher from 'services/account-switcher';

import Admin from './Admin';
import Accounts from './Accounts';
import Account from './Account';
import Unauthorised from '../unauthorised/Unauthorised.jsx';

const superUserCheckedAction = (action) => (...args) => {
  const canSwitch = AccountSwitcher.canSwitch();
  if (!canSwitch) {
    return <Unauthorised />;
  }
  return action(...args);
};

const routes = new Route({
  path: '/admin',
  children: [
    {
      name: 'Accounts',
      path: '/',
      action: superUserCheckedAction(() => {
        return (
          <Admin>
            <Accounts />
          </Admin>
        );
      }),
    },
    {
      name: 'Accounts',
      path: '/:accountId',
      action: superUserCheckedAction((context) => {
        return (
          <Admin>
            <Account accountId={Number(context.params.accountId)} />
          </Admin>
        );
      }),
    },
  ],
});

export default routes;
